'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { useRoleAuth } from '@/contexts/RoleAuthContext';

/**
 * Signed-in users land on /dashboard instead of the marketing homepage.
 * Renders before auth resolves (SSR + first client paint) so anonymous
 * visitors see the marketing page with no flash; the overlay only appears
 * once auth has actually resolved to a logged-in user.
 */
export default function HomeAuthRedirect() {
  const { roleUser, roleLoading } = useRoleAuth();
  const router = useRouter();

  useEffect(() => {
    if (!roleLoading && roleUser) {
      router.replace('/dashboard');
    }
  }, [roleUser, roleLoading, router]);

  if (roleLoading || !roleUser) return null;

  return (
    <div
      aria-hidden
      className="fixed inset-0 z-[9999] bg-[#0a0e1a] flex items-center justify-center"
    >
      <div className="w-8 h-8 rounded-full border-2 border-violet-500 border-t-transparent animate-spin" />
    </div>
  );
}
